import gql from 'graphql-tag';
import { apollo, i18n } from 'src/features';

const mutation = gql`
mutation Registration($name: String!, $authId: String!){
  registerCustomer(name: $name, authId: $authId) {
    token
    authorizable {
      ... on Customer {
        id
        firstName
        lastName
        middleName
      }
    }
  }
}`;

function parse(item) {
  return {
    token: item.token,
    customer: {
      id: item.authorizable.id,
      title: item.authorizable.firstName,
      firstName: item.authorizable.firstName,
      middleName: item.authorizable.middleName,
      lastName: item.authorizable.lastName,
      identified: true,
    },
  };
}

function registrationCustomer(name, authId) {
  return apollo.client.mutate({
    variables: { name, authId },
    mutation,
  }).then((res) => parse(res.data.registerCustomer))
    .catch((err) => {
      if (err.graphQLErrors.length) {
        const errors = err.graphQLErrors[0].message;
        throw i18n.t(errors);
      } else {
        throw err;
      }
    });
}

export default registrationCustomer;
